import React, { Component } from "react"
import { graphql } from "gatsby"
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'
import moment from "moment"

import Seo from "../components/seo"

import RenderBlock from "../utils/render-block"

class PostTemplate extends Component {
  render() {
    let post = this.props.data.articles.post
    let category = post?.categories?.nodes[0]?.name

    return (
      <>
        <Seo bodyClass='single-post' {...post.seo} />
        <section className='single-post__header'>
          <div className='single-post__inner'>
            { post.title && <h1>{parse(post.title)}</h1> }
            { category &&
              <ul className='single-post__meta'>
                <li><span>{category}</span><span className='divider'>•</span><span>{moment(post.date).format('DD MMM YYYY')}</span></li>
              </ul>
            }
          </div>
        </section>
        <section className='post-image post-image--featured'>
          <Fade distance='40px' bottom>
            <div className="post-image__inner">
              { post.featuredImage?.node.mediaItemUrl && <img className='post-image__img' src={ post.featuredImage.node.mediaItemUrl} alt={post.title} /> }
              { post.featuredImage?.node?.localFile && <img className="post-image__img" src={post.featuredImage.node.localFile.publicURL} alt={post.title} /> }
              { post.featuredImage?.node?.caption && <div className="post-image__caption">{ parse(post.featuredImage.node.caption) }</div> }
            </div>
          </Fade>
        </section>
        { post?.acf?.blocks?.map((el, i) => RenderBlock(el.fieldGroupName, el, i, this.props)) }
        { post.acf?.author && 
          <ul className='single-post__meta single-post__meta--footer'>
            <li><span>Author</span><span className='divider'>•</span><span>{post?.acf?.author}</span></li>
          </ul>
        }
      </>
    )
  }
}

export const postQuery = graphql`
  query PostTemplateQuery ($id: ID!) {
    articles {
      post(id: $id) {
        title
        slug
        seo {
          metaDesc
          metaKeywords
          metaRobotsNofollow
          opengraphAuthor
          opengraphDescription
          opengraphImage {
            mediaItemUrl  
          }
          opengraphModifiedTime
          opengraphPublishedTime
          opengraphPublisher
          opengraphSiteName
          opengraphTitle
          opengraphType
          opengraphUrl
          readingTime
          schema {
            articleType
            pageType
            raw
          }
          title
          twitterDescription
          twitterImage {
            mediaItemUrl
          }
          twitterTitle
        }
        date
        categories {
          nodes {
            name
            slug
          }
        }
        featuredImage {
          node {
            mediaItemUrl
            caption
          }
        }
        acf {
          author
          blocks {
            ... on ARTICLES_Post_Acf_Blocks_Content {
              fieldGroupName
              content
              largeFont
            }
            ... on ARTICLES_Post_Acf_Blocks_Image {
              fieldGroupName
              image {
                mediaItemUrl
                caption
              }
              wide
            }
            ... on ARTICLES_Post_Acf_Blocks_DoubleImage {
              fieldGroupName
              imageOne {
                mediaItemUrl
                caption
              }
              imageTwo {
                mediaItemUrl
                caption
              }
            }
          }
        }
      }
    }
  }
`

export default PostTemplate
